import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export interface FilterSummaryPart {
  label: string;
}

@Component({
  standalone: true,
  selector: 'app-filter-summary',
  templateUrl: './filter-summary.component.html',
  imports: [CommonModule, MatIconModule],
})
export class FilterSummaryComponent {
  @Input() itemCount: number = 0;
  @Input() itemLabel: string = 'items';
  @Input() parts: string[] = [];
  @Input() hasFilters: boolean = false;
  @Output() clearAll = new EventEmitter<void>();

  onClearAll(): void {
    this.clearAll.emit();
  }
}
